import { LegalPage } from "@/pages/PrivacyPolicy";

const SECTIONS = [
  ["Indicative information", [
    "All PPA rates, system sizes, generation estimates and savings figures shared by Be Green Group are indicative only.",
    "Actual figures depend on site inspection, engineering design, network approval, funding approval, credit approval and execution of a formal PPA.",
  ]],
  ["Eligibility", [
    "Not every business is eligible. Eligibility depends on annual electricity usage, site condition, load profile, ownership structure, credit and network approvals.",
  ]],
  ["Grid electricity", [
    "The Be Green PPA covers energy supplied from the on-site solar and battery system only.",
    "Grid electricity supply remains billed by your existing electricity retailer.",
  ]],
  ["Savings", [
    "Any potential savings shared by Be Green Group are indicative estimates. They are not guaranteed.",
    "Estimated savings depend on future electricity prices, business usage and site conditions.",
  ]],
];

export default function PPADisclaimer() {
  return (
    <LegalPage
      title="PPA Disclaimer"
      testId="ppa-disclaimer-page"
      sections={SECTIONS}
      intro="This disclaimer explains the indicative nature of information Be Green Group shares about its commercial PPA offering."
    />
  );
}
